export const PAYMENT_METHOD_TYPES = 'card'
